<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
          <h1 class="tac login_big">Forgot password?</h1>
        </div>

        <div class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12">
          <form v-on:submit="resetPassword">
            <div class="row">
              <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
                <inputWrap
                    :title="'Email address'"
                    :type="'email'"
                    :placeholder="'e.g., edithanderson@gmail.com'"
                    :name="'email'"
                    :id="'email'"
                    :required="true"
                    :inputData.sync="email"
                ></inputWrap>
              </div>

              <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
                <div class="df s_betwen login_lover_links_wrap">
                  <router-link
                      to="/auth/login"
                      class="login_lover_links hover_op"
                  >Already have an account?
                  </router-link
                  >
                  <router-link
                      to="/auth/sign-up"
                      class="login_lover_links hover_op"
                  >Dont have an account?
                  </router-link
                  >
                </div>
              </div>

              <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
                <input
                    type="submit"
                    value="Reset password"
                    class="color_btn hover_op"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import inputWrap from "@/components/inputWrap.vue";
import {getAuth, sendPasswordResetEmail} from "firebase/auth";
import apiClient from "../apiClient";

export default {
  name: "PasswordReset",
  data() {
    return {
      email: "",
    };
  },

  components: {
    inputWrap,
  },

  methods: {
    async resetPassword(event) {
      try {
        event.preventDefault();

        await apiClient.post("/user/password-change-request", {email: this.email})

        this.$store.dispatch(
            "onSuccess",
            "If you have an account with us, you will receive a link to reset your password."
        );
        this.email = "";
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
</style>
